import React from "react";
import classNames from "classnames";
import Icon from "../Icon/Icon";
var css = {
  "labelWrapper": "rui-823AO",
  "primary": "rui-wHrvS",
  "secondary": "rui-Jbuo4",
  "disabled": "rui-nilAo",
  "iconWrapper": "rui-SDjeq"
};
var Label = function Label(_ref) {
  var content = _ref.content,
    _ref$onLabelClick = _ref.onLabelClick,
    onLabelClick = _ref$onLabelClick === void 0 ? function () {} : _ref$onLabelClick,
    _ref$onIconClick = _ref.onIconClick,
    onIconClick = _ref$onIconClick === void 0 ? function () {} : _ref$onIconClick,
    _ref$labelClickData = _ref.labelClickData,
    labelClickData = _ref$labelClickData === void 0 ? {} : _ref$labelClickData,
    _ref$iconClickData = _ref.iconClickData,
    iconClickData = _ref$iconClickData === void 0 ? {} : _ref$iconClickData,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$dataAutId = _ref.dataAutId,
    dataAutId = _ref$dataAutId === void 0 ? "" : _ref$dataAutId,
    _ref$iconClass = _ref.iconClass,
    iconClass = _ref$iconClass === void 0 ? "" : _ref$iconClass,
    _ref$iconConfig = _ref.iconConfig,
    iconConfig = _ref$iconConfig === void 0 ? {
      icon: "cross"
    } : _ref$iconConfig,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
    _ref$secondary = _ref.secondary,
    secondary = _ref$secondary === void 0 ? false : _ref$secondary,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var labelClickHandler = function labelClickHandler(e) {
    return onLabelClick(e, labelClickData);
  };
  var iconClickHandler = function iconClickHandler(e) {
    return onIconClick(e, iconClickData);
  };
  var labelWithIconClass = showIcon ? css.labelIcon : "";
  var state = css.primary;
  if (disabled) {
    state = css.disabled;
  } else if (secondary) {
    state = css.secondary;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.labelWrapper, labelClass, labelWithIconClass, state),
    onClick: labelClickHandler,
    onKeyDown: labelClickHandler,
    "data-aut-id": dataAutId,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: css.content
  }, content), showIcon && /*#__PURE__*/React.createElement("span", {
    className: classNames(css.iconWrapper, iconClass),
    onClick: iconClickHandler,
    onKeyDown: iconClickHandler,
    role: "listbox",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, Object.assign({}, iconConfig))));
};
export default Label;